import React, { Suspense, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import { Button, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popconfirm } from "antd";
import ReactTable from "react-table";
import { closeCustomModal, openCustomModal } from "components/custom/modals";
import VacationEdit from "components/menu/profile/vacation-edit";
import {
    profileGetVacations,
    profileDeleteVacations
} from "api/menu/profile/actions";

const Vacations = (props) => {
    const refTable = useRef(null);

    const {
        profileGetVacations,
        profileDeleteVacations,
        vacations,
    } = props;

    useEffect(() => {
        profileGetVacations();
    }, [profileGetVacations]);

    const handleEdit = (id = false) => {
        const modalTitle = id !== false ? "Update" : "Create";

        const modalObj = {
            id: `edit-vacation-${id}`,
            header: `${modalTitle} Vacation`,
            children: (
                <Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <VacationEdit
                        id={id}
                        onCancel={() => props.closeCustomModal(modalObj)}
                    />
                </Suspense>
            ),
            handleClose: () => props.closeCustomModal(modalObj)
        };
        props.openCustomModal(modalObj);
    };

    return (
        <div>
            <div className="d-flex justify-content-between mb-3">
                <h4 className="m-0">Vacations</h4>
                <button
                    className="btn btn-success"
                    onClick={() => handleEdit()}
                >
                    Add Vacation
                </button>
            </div>
            <div>
                <ReactTable
                    ref={refTable}
                    data={vacations}
                    columns={[{
                        id: "vacation-type",
                        Header: "Type",
                        headerClassName: "text-left",
                        accessor: original => (original.isVacation ? "Vacation" : "Off"),
                        Cell: ({ original }) => {
                            const partial = original.isPartial ? "(Partial)" : "";
                            return original.isVacation
                                ? `Vacation ${partial}`
                                : `Off ${partial}`;
                        }
                    }, {
                        id: "vacation-dates",
                        Header: "Dates",
                        headerClassName: "text-left",
                        accessor: "endDate",
                        Cell: ({ original }) => {
                            const start = moment(original.startDate),
                                end = moment(original.endDate);
                            const diffHours = moment(original.endDate)
                                .diff(original.startDate, "hours");
                            if (!original.isPartial && diffHours !== 0) {
                                return `${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`;
                            } else if (diffHours === 0) {
                                return start.format("MMMM D, YYYY");
                            }
                            return `${start.format("MMMM D, YYYY")} - (${start.format("h:mm A")} - ${end.format("h:mm A")})`;
                        }
                    }, {
                        Header: "Actions",
                        className: "text-center",
                        Cell: ({ original }) => {
                            if (moment(original.endDate).diff(moment()).valueOf() < 0) {
                                return null;
                            }
                            return (
                                <ButtonGroup>
                                    <Button size="sm" onClick={() => handleEdit(original.id)}>
                                        <FontAwesomeIcon icon="pen" title="Update" />
                                    </Button>
                                    <Popconfirm
                                        title="Delete?"
                                        onConfirm={() => profileDeleteVacations(original.id)}
                                        placement="bottomRight"
                                        okText="Yes"
                                        cancelText="Cancel"
                                    >
                                        <Button variant="danger" size="sm">
                                            <FontAwesomeIcon icon="times" />
                                        </Button>
                                    </Popconfirm>
                                </ButtonGroup>
                            );
                        },
                    }]}
                    headerClassName="table-header"
                    showPagination={true}
                    pageSize={10}
                    resizable
                    className="-striped -highlight"
                    defaultSorted={[{
                        id: "vacation-dates",
                        desc: true
                    }]}
                    filterable={false}
                    style={{
                        height: 300,
                    }}
                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                            if (!rowInfo.row.isDeleted) {
                                return {};
                            }
                            return {
                                style: {
                                    background: "#FF000080",
                                    color: "#FFF",
                                }
                            };
                        }
                        return {};
                    }}
                />
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    loading: state.profile.loading,
    specialAvailability: state.profile.specialAvailability,
    vacations: state.profile.vacations,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    profileGetVacations: bindActionCreators(profileGetVacations, dispatch),
    profileDeleteVacations: bindActionCreators(profileDeleteVacations, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(Vacations);
